import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { compose } from '../../../util'
import { injectIntl } from 'react-intl'
import { WizardDialogButton } from '../../../components/add-agent/dialog/wizard-dialog-button'
import { sendDefaultEvent } from '../../../components/analytics'
import { WizardDialog } from '../../../components/add-agent/dialog/wizard-dialog'

import { UseAddAgentConnectionStatusContextProvider } from '../../../components/add-agent/use-add-agent-connection-status'
import {
  useAddAgentWizard,
  UseAddAgentWizardProvider
} from '../../../components/add-agent/use-add-agent-wizard'

export function Bridge({
  getRouteHistory
}: {
  getRouteHistory: () => string[]
}) {
  const { organizationUuid, initialRoute, wizardConfig, currentStepIndex } =
    useAddAgentWizard()

  return (
    <>
      <WizardDialogButton
        href={initialRoute}
        onClick={() => {
          sendDefaultEvent('app.agent.add')
        }}
      />
      <UseAddAgentWizardProvider
        organizationUuid={organizationUuid}
        getRouteHistory={getRouteHistory}
      >
        <UseAddAgentConnectionStatusContextProvider
          organizationUuid={organizationUuid}
          wizardConfig={wizardConfig}
          currentStepIndex={currentStepIndex}
        >
          <WizardDialog />
        </UseAddAgentConnectionStatusContextProvider>
      </UseAddAgentWizardProvider>
    </>
  )
}

const BridgeWithProviders = ({ organizationId, getRouteHistory }) => {
  if (!organizationId) {
    throw new Error('organizationID is required')
  }
  if (!getRouteHistory) {
    throw new Error('getRouteHistory is required')
  }
  return (
    <UseAddAgentWizardProvider
      organizationUuid={organizationId}
      getRouteHistory={getRouteHistory}
    >
      <Bridge getRouteHistory={getRouteHistory} />
    </UseAddAgentWizardProvider>
  )
}

export const reactAddAgentWizard = createNgReactBridgeDirective(
  'reactAddAgentWizard',
  [],
  compose(injectIntl)(BridgeWithProviders),
  ['organizationId', 'getRouteHistory']
)
